import { createSelector } from 'reselect'
import {
  PRODUCT_MODEL_KEY,
  PRODUCT_MODEL_SIZE
} from 'models/daos/product/constants'
import getInstanceSectionSelector from 'modules/section/selectors/get-instance'
import { getFirstProductQuantityInStockProductUtil } from 'models/daos/product/utils'
import { getDomainMapValueReduxUtil } from 'modules/redux/utils/get-domain-map-value'
import { isExpiredPromoCodeUtil } from 'models/daos/promo-code/utils'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import sortByArrayUtil from 'packages/src/modules/array/sort-by/index.js'
import { compactArrayUtil } from 'packages/src'

/**
 * Gets the product's product quantities.
 * @returns {ProductQuantities[]}
 */
function getProductQuantitiesProductsSelector () {
  return createSelector(
    state => state && state.productQuantities,
    (state, props) => props.instance || getInstanceSectionSelector()(state, props),
    (domain, product) => {
      // Get the product quantities pointers
      const productQuantitiesPointers = getValueReduxUtil(product, PRODUCT_MODEL_KEY.PRODUCT_QUANTITIES) || []
      // Get the product quantities
      const productQuantities = compactArrayUtil(
        productQuantitiesPointers.map(productQuantityPointer => (
          domain.data[getDomainMapValueReduxUtil(productQuantityPointer)])
        )
      )
      // Sort the product quantities
      return sortByArrayUtil(productQuantities, p => Object.values(PRODUCT_MODEL_SIZE).indexOf(p.data.name))
    }
  )
}

/**
 * Gets the product's quantities.
 * @returns {PromoCode[]}
 */
function getPromoCodesProductSelector () {
  return createSelector(
    state => state && state.promoCodes,
    (state, props) => props.instance || getInstanceSectionSelector()(state, props),
    (domain, product) => {
      // Get the product quantities pointers
      const promoCodePointers = getValueReduxUtil(product, PRODUCT_MODEL_KEY.PROMO_CODES) || []
      // Get the product quantities
      return compactArrayUtil(
        promoCodePointers.map(promoCodePointer => {
          const promoCode = domain.data[getDomainMapValueReduxUtil(promoCodePointer)]
          return isExpiredPromoCodeUtil(promoCode) ? null : promoCode
        })
      )
    }
  )
}

/**
 * Selects the product quantities of the given product and check if it's
 * out of stock.
 * @returns {boolean}
 */
function isOutOfStockProductSelector () {
  return createSelector(
    getProductQuantitiesProductsSelector(),
    (productQuantities) => (
      !getFirstProductQuantityInStockProductUtil(productQuantities)
    )
  )
}

export {
  getProductQuantitiesProductsSelector,
  getPromoCodesProductSelector,
  isOutOfStockProductSelector
}
